import React, {useState} from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import TableSearch from "@/components/table/tableSearch";
import {refundApi} from "@/api/refund";

import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";
import {sprintf} from "@/lib/utils/sprintf";
import RefundStatusEnumComponent from "@/components/EnumComponents/RefundStatusEnumComponent";
import {formatDateFull} from "@/lib/utils/date";
import {Link} from "react-router-dom";
import { Button, Select } from "antd";

function AdminRefundGroupListPage(props) {
    const [needRefetch, setNeedRefetch] = useState(false)
    const [status, setStatus] = useState('')



    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            render: function (text, record) {
                return toFaNumber(text)
            }
        },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',

        },

        {
            title: 'تعداد',
            dataIndex: 'refunds_count',
            key: 'refunds_count',
            render: function (text, record) {
                return (<>
                    <div className="flex gap-1">
                        {toFaNumberFormat(text)}
                        <span className={'text-gray-400'}>درخواست</span>
                    </div>

                </>)

            }
        },
        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            render: function (text, record) {
                return (
                    <>
                        <div className="flex flex-wrap gap-1">
                            <RefundStatusEnumComponent text={text}/>

                        </div>

                    </>

                )
            }
        },

        {
            title: 'تاریخ درخواست',
            dataIndex: 'created_at',
            key: 'created_at',
            render: function (text, record) {
                return formatDateFull(text)
            }
        },
        {
            title: '',
            dataIndex: 'id',
            key: 'edit',
            render: function (text, record) {
                return (<Link to={sprintf(URLS.admin.refund.group.edit, {id: record.id})}>
                    <Button type={'dashed'} size={'small'}>
                        نمایش
                    </Button>
                </Link>)

            }
        },
    ]

    const statusList = [
        {key: '', fa: 'همه',},
        {key: 'pending', fa: 'در انتظار',},
        {key: 'approved', fa: 'تایید شده',},
        {key: 'rejected', fa: 'رد شده',},
        {key: 'cancelled', fa: 'لغو شده',},
        {key: 'payed', fa: 'پرداخت شده',},
    ]


    return (
        <AdminLayout
            pageTitle="لیست گروه‌های بازگشت وجه"
            backTo={URLS.admin.refund.dashboard}
        >

            <TableSearch
                searchInput={true}
                addButton={<>
                    <div className="flex flex-wrap gap-1 justify-between">
                        <div className="flex flex-wrap gap-1 items-center mx-1">
                            <span className={'text-gray-400 text-xs'}>وضعیت</span>
                            <Select
                                defaultValue={status}
                                value={status}
                                className={'w-32'} onChange={(e) => setStatus(e)}>
                                {statusList.map((item, index) => (
                                    <Select.Option key={item.key + index} value={item.key}>{item.fa}</Select.Option>
                                ))}
                            </Select>
                        </div>

                        <div>
                            <Link to={URLS.admin.refund.group.create}>
                                <Button
                                    type={'primary'}
                                >
                                    ثبت گروه جدید
                                </Button>
                            </Link>
                        </div>

                    </div>


                </>}
                apiFn={refundApi.useAdminGroupList}
                needRefetch={needRefetch}
                fnArgs={{status: status}}
                setNeedRefetch={setNeedRefetch}
                columns={columns}/>

        </AdminLayout>
    );
}

export default AdminRefundGroupListPage;